import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutSmsMessageDetails extends Layout {
	sourceCarrierDriver: DataSource;
	sourceCarrierDriverMessage: DataSource;
	sourceMmsMedia: DataSource;
	tableSmsMessages: Table;
}
